import { FunnelManagementClientWrapper } from './FunnelManagementClientWrapper';

export default function FunnelManagementPage() {
    return (
        <div>
            <FunnelManagementClientWrapper />
        </div>
    );
}
